import Tab from '@/types/Tab'

export default function (id) {
	return [
		new Tab('namespaces', {
			to: { name: 'website-template-namespaces' },
			name: 'Namespaces',
			value: `/website-templates/${id}/namespaces`,
		}),
		new Tab('strings', {
			to: { name: 'website-template-strings' },
			name: 'Strings',
			value: `/website-templates/${id}/strings`,
		}),
		new Tab('pages', {
			to: { name: 'website-template-pages' },
			name: 'Fixed Pages',
			value: `/website-templates/${id}/pages`,
		}),
		new Tab('pagetemplates', {
			to: { name: 'website-template-pagetemplates' },
			name: 'Page Templates',
			value: `/website-templates/${id}/pagetemplates`,
		}),
	]
}
